<template>
    <div>
        <el-form ref='ruleForm' :model="rulesform" label-width="160px" class="event-form">
            <el-form-item label="关联配置项:">
                <router-link :to="{ path: '/relevancyConfig',query:{callback:relevancyConfig}}">
                    <el-button type="primary">新增</el-button>
                </router-link>
                <relevancy-tab :data="rulesform.targetSerialNumber" :getData="getCmdbData"></relevancy-tab>
                <!--<div class="el-form__inline">-->
                    <!--<el-input v-model="rulesform.targetSerialNumber"></el-input>-->
                    <!--<el-button @click="innerVisible = true" type="primary">选择</el-button>-->
                <!--</div>-->

                <!--<div contenteditable='true' class='targetSerialNumberBox' @click="innerVisible = true">-->
                    <!--{{rulesform.targetSerialNumber}}-->
                <!--</div>-->
            </el-form-item>
            <el-form-item label="关联应用:">
                <router-link :to="{ path: '/relevancyApp',query:{callback:relevancyApp}}">
                    <el-button type="primary">新增</el-button>
                </router-link>
                <relevancyTabAPP :data="rulesform.toApp" :getData="getAppData"></relevancyTabAPP>
            </el-form-item>
            <el-form-item label="配置项CI的关系类型:">
                <el-select v-model="rulesform.relationship" placeholder="请选择">
                    <el-option
                     v-for="item in cmdbRelationshipType"
                     :key="item.id"
                     :label="item.cname"
                     :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="备注:">
                <el-input v-model="rulesform.description" type='textarea'></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type='primary' @click='submitForm("ruleForm")' :disabled="isSubmit">确定</el-button>
                <el-button type='primary' @click='ResetForm("ruleForm")'>重置</el-button>
            </el-form-item>
        </el-form>

        <!--&lt;!&ndash; 内弹框 &ndash;&gt;-->
        <!--<el-dialog title="添加配置项关系" :visible.sync="innerVisible" append-to-body>-->
            <!--<div>-->
                <!--<add-configuration :getServes='suremit' ></add-configuration>-->
                <!--&lt;!&ndash;<el-button type="primary" @click="suremit">确 ?定</el-button>&ndash;&gt;-->
            <!--</div>-->
        <!--</el-dialog>-->

    </div>
</template>

<script>
import services from './configuration.services'
import relevancyTab from "../common/relevancyTab.vue"
import relevancyTabAPP from './relevancyTabAPP'

import addConfiguration from '../../components/addConfiguration'
export default {

    components: { addConfiguration,relevancyTab ,relevancyTabAPP},

    props: {
        serialNumber: String,
        callback: Function
    },

    data() {
        return {
            rulesform: {
                serialNumber: this.serialNumber,
                targetSerialNumber: [],
                toApp:[],
                relationship: '377',
                description: ''
            },
            toAppName:[],
            toAppId:[],
            toConfigName:[],
            toConfigId:[],
            // innerVisible: false,
            getData: [],
            isSubmit:false
        }
    },

    computed: {

        // 数据字典
        dictionary() {
            return this.$store.state.dictionary
        },

        // 配置项CI的关系类型
        cmdbRelationshipType() {
            return this.dictionary.cmdb_relationship_type
        }
    },

    methods: {
        // 确认按钮
        submitForm(formName) {
            this.isSubmit=true
            this.$refs[formName].validate(valid => {
                if (valid) {
                    // this.rulesform.targetSerialNumber = this.getData.map(item => item.serialNumber)
                    this.rulesform.targetSerialNumber=[].concat(this.toConfigId,this.toAppId)
                    // this.rulesform.toApp=this.toAppId
                    let params={
                        serialNumber: this.serialNumber,
                        targetSerialNumber: this.rulesform.targetSerialNumber,
                        relationship: this.rulesform.relationship,
                        description: this.rulesform.description,
                    }
                    services.cmdbRelationshipAdd(params)
                        .then(res => this.$message.success('添加成功'))
                        .catch(err => {
                            this.isSubmit=false
                            this.$message.error(err.message)
                        })
                        .finally(() => {
                            this.$modal.close();
                            this.callback();
                        })
                }else{
                    this.isSubmit=false
                    this.$message.error('✳为必填项，请全部填写')
                }
            });
        },

        // 重置  targetSerialNumber
        ResetForm(formName) {
            this.rulesform = {
                serialNumber: this.serialNumber,
                targetSerialNumber: '',
                toApp:'',
                relationship: '377',
                description: ''
            }
        },
        //获取选择后的关联的配置项
        relevancyConfig(val){
            this.rulesform.targetSerialNumber=this.rulesform.targetSerialNumber.concat(val)
            val.forEach(item => {
                this.toConfigName.push(item.title);
                this.toConfigId.push(item.serialNumber);
            });
        },
        //获取选择后的关联的应用
        relevancyApp(val){
            this.rulesform.toApp=this.rulesform.toApp.concat(val)
            val.forEach(item => {
                this.toAppName.push(item.name);
                this.toAppId.push(item.id.toString());
            });
        },
        getCmdbData(val){ this.rulesform.targetSerialNumber  = val;},
        getAppData(val){ this.rulesform.toApp  = val;},

        suremit(nodes) {
            this.getData = nodes
            this.rulesform.targetSerialNumber = this.getData.map(item => item.title).join()
            this.innerVisible = false
        }

    }
}
</script>

<style scoped>
    .targetSerialNumberBox {
        width: 200px;
        height: 28px;
        border: 1px solid #C0C4CC;
        border-radius: 4px;
        overflow: hidden;
    }
</style>
